import React, { useEffect, useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import {
    lateclockinrequests,
    lateclockinaction,
} from "../../../services/attendance";

const isAdmin = localStorage.getItem("Role") === "1";

export const LateApprovals = () => {
    const [rows, setRows] = useState([]);
    const [status, setStatus] = useState("");

    const [show, setShow] = useState(false);
    const [modalRow, setModalRow] = useState(null);
    const [modalAction, setModalAction] = useState("approve");
    const [remarks, setRemarks] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        loadList(status);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    const loadList = async (filterStatus) => {
        const res = await lateclockinrequests({ status: filterStatus });
        if (res && res.status === true) {
            setRows(res.data.requests.data);
        }
    };

    const handleaction = (row, action) => {
        setModalRow(row);
        setModalAction(action);
        setRemarks("");
        setShow(true);
    };

    const submitAction = async () => {
        if (!modalRow) return;
        setSubmitting(true);
        const res = await lateclockinaction({
            id: modalRow.id,
            action: modalAction,
            remarks: remarks || "",
        });
        setSubmitting(false);
        if (res) {
            res.status === true ? toast.success(res.message) : toast.info(res.message);
            setShow(false);
            loadList(status);
        }
    };

    const badge = (value) => {
        if (value === "approved") return "badge bg-success";
        if (value === "rejected") return "badge bg-danger";
        return "badge bg-warning";
    };

    const columnDefs = [
        {
            headerName: "S.No",
            valueGetter: "node.rowIndex + 1",
            width: 90,
            sortable: false,
            filter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff",
            field: "user.name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) =>
                params.value ? moment(params.value).format("DD/MM/YYYY") : "-",
        },
        {
            headerName: "Requested At",
            field: "requested_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            width: 180,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) =>
                params.value ? moment(params.value).format("DD/MM/YYYY hh:mm A") : "-",
        },
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: (params) => (
                <span>
                    <span className={badge(params.value)}>{params.value}</span>
                    {params.data.consumed ? (
                        <span className="badge bg-secondary ms-1">used</span>
                    ) : null}
                </span>
            ),
        },
        {
            headerName: "Approved By",
            field: "approver.name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) => params.value || "-",
        },
        {
            headerName: "Remarks",
            field: "remarks",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) => params.value || "-",
        },
        ...(isAdmin
            ? [
                  {
                      headerName: "Action",
                      field: "id",
                      width: 190,
                      sortable: false,
                      filter: false,
                      cellStyle: { textAlign: "left" },
                      cellRenderer: (params) => {
                          if (params.data.consumed && params.data.status !== "pending") {
                              return <span>-</span>;
                          }
                          return (
                              <div>
                                  <button
                                      className="btn btn-sm btn-success me-1"
                                      onClick={() => handleaction(params.data, "approve")}
                                      disabled={params.data.status === "approved"}
                                  >
                                      Approve
                                  </button>
                                  <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleaction(params.data, "reject")}
                                      disabled={params.data.status === "rejected"}
                                  >
                                      Reject
                                  </button>
                              </div>
                          );
                      },
                  },
              ]
            : []),
    ];

    return (
        <div className="app-content main-content">
            <div className="side-app main-container">
                <div className="page-header d-xl-flex d-block">
                    <div className="page-leftheader">
                        <div className="page-title">Late Clock In Approvals</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Requests</h4>
                                <div className="ms-auto" style={{ width: "200px" }}>
                                    <select
                                        className="form-control"
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="approved">Approved</option>
                                        <option value="rejected">Rejected</option>
                                    </select>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rows}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header>
                    <h4>
                        {modalAction === "approve"
                            ? "Approve Late Clock In"
                            : "Reject Late Clock In"}
                    </h4>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <p className="mb-3">
                                {modalAction === "approve"
                                    ? "Approve late clock in for "
                                    : "Reject late clock in for "}
                                <strong>
                                    {modalRow && modalRow.user
                                        ? modalRow.user.name
                                        : "this staff"}
                                </strong>
                                {modalRow ? (
                                    <>
                                        {" "}
                                        on{" "}
                                        <strong>
                                            {moment(modalRow.date).format("DD/MM/YYYY")}
                                        </strong>
                                    </>
                                ) : null}
                                ?
                            </p>
                            <div className="mb-3">
                                <label className="form-label">Remarks (optional)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter remarks"
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a
                        className={
                            modalAction === "approve"
                                ? "btn btn-success"
                                : "btn btn-danger"
                        }
                        onClick={submitting ? undefined : submitAction}
                    >
                        {submitting
                            ? "Processing..."
                            : modalAction === "approve"
                            ? "Approve"
                            : "Reject"}
                    </a>
                    <a className="btn btn-info" onClick={() => setShow(false)}>
                        Close
                    </a>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default LateApprovals;
